import { render, staticRenderFns } from "./SupplierTickets.vue?vue&type=template&id=4b9202f0&"
import script from "./SupplierTickets.vue?vue&type=script&lang=js&"
export * from "./SupplierTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports